/* eslint-disable @typescript-eslint/no-explicit-any */
import to from "await-to-js";
import { BodyParam } from "@/app/csr-src/apis/cart/cart.interface";
import { addCart } from "@/app/csr-src/apis/cart/cart.api";
import { getUserUUIDFromCookie } from "@/utils/userUtils";
import UKToast from "@/common-components-src/components/UKToast/index";;

/**
 * 加入购物车
 * @param productList - [{ skuId: 88, num: "1" }] 加入购物车所需的参数
 * @param refreshCb -  加入购物车成功后刷新头部购物车数量
 */
export const addCartUtil = async (productList: any[], refreshCb?: () => void) => {
  const formatProductList = productList.map((item) => {
    item.itemType = 1;
    return item;
  });
  const bodyParam: BodyParam = {
    longitude: "",
    latitude: "",
    client: "pc",
    clientVersion: "1.0.0",
    verticalTag: "cn_ybxt_b2c",
    area: "",
    operations: { products: formatProductList },
    cartuuid: getUserUUIDFromCookie(),
    userActionId: "addCart",
  };
  const [err, result] = await to(addCart(bodyParam));

  if (err) {
    UKToast.show({
      content: "Failed to add to cart. The product is no longer available", // 弹窗内容
      icon: "error", // 可选：success, fail, loading, warn, info，影响图标
    });
  } else {
    if (result?.code === "200") {
      UKToast.show({
        content: "Added to cart", // 弹窗内容
        icon: "success", // 可选：success, fail, loading, warn, info，影响图标
      });
      setTimeout(() => {
        refreshCb && refreshCb();
      }, 3000);
    } else {
      UKToast.show({
        content: "Added to cart failed, please try again", // 弹窗内容
        icon: "warning", // 可选：success, fail, loading, warn, info，影响图标
      });
    }
  }
};
